module.exports = __webpack_public_path__ + "img/paymaya.0b75c7b2.svg";